<template>
    <div class="comMap chartConfig_viewDP">
        <div class="chartDivConfig checkViewConfig">
            <el-checkbox v-model="config.tooltip.show" @change="getRender">是否展示弹板</el-checkbox>
        </div>
        <div class="chartDivConfig colViewConfig">
            <span class="span_til">背景颜色</span>
            <el-color-picker v-model="config.tooltip.backgroundColor" show-alpha @change="getRender"></el-color-picker>
        </div>
        <div class="chartDivConfig numViewConfig">
            <span class="span_til">边框宽</span>
            <el-input v-model="config.tooltip.borderWidth" @change="getRender" type="number" min="0"></el-input>
        </div>
        <div class="chartDivConfig colViewConfig">
            <span class="span_til">边框颜色</span>

            <el-color-picker v-model="config.tooltip.borderColor" show-alpha @change="getRender"></el-color-picker>
        </div>
        <div class="chartDivConfig numViewConfig">
            <span class="span_til">内边距</span>
            <el-input v-model="config.tooltip.padding" @change="getRender" type="number" min="0"></el-input>
        </div>
        <div class="chartDivConfig colViewConfig">
            <span class="span_til">字体颜色</span>
            <el-color-picker v-model="config.tooltip.textStyle.color" show-alpha @change="getRender"></el-color-picker>
        </div>
        <div class="chartDivConfig numViewConfig">
            <span class="span_til">字体大小</span>
            <el-input v-model="config.tooltip.textStyle.fontSize" @change="getRender" type="number" min="0"></el-input>
        </div>

    </div>
</template>

<script>
    /**
     @author xiaoye
     @date 2020/4/24 8:04 下午
     */
    export default {
        name: 'map_config',
        components: {},
        data() {
            return {
                triggerList: [
                    {value: 'item', label: '数据项图形触发'},
                    {value: 'axis', label: '坐标轴触发'},
                    {value: 'none', label: '不触发'},

                ],
            }
        },
        props: {
            type: {
                type: String,
                default: ''
            },
        },
        computed: {
            config() {
                if (this.type === 'view') {
                    return this.$store.state.viewDP.chart.setting.params;
                } else if (this.type === 'screen') {
                    return this.$store.state.designer.chart.setting.params;
                }
            },
        },
        methods: {
            getRender() {
                if (this.type === 'view') {
                    this.$store.dispatch('viewDPRender');
                } else if (this.type === 'screen') {
                    this.$store.dispatch('screenRender');
                }
            },
        },
        mounted() {

        },
        destroyed() {

        }

    }
</script>

<style lang="less">
    .map_config {

    }
</style>